<script>
import Menu from '../menu.svelte'
import Map from './map.svelte'

    
import { y_last } from "../stores1"
var y_value = 0;
y_last.set(y_value)
    
var menu_counter = 0
    
const hamburger = () => {
    menu_counter++
}

import { nightmode } from "../stores5"
</script>
    
<div class="hamburger" class:hamburger-night={$nightmode} id="hamburger" on:click={hamburger}>
    <div class="bar1"></div>
    <div class="bar2"></div>
    <div class="bar3"></div>
</div>
    
{#if menu_counter % 2 === 0}
<Map/>
{/if}
    
{#if menu_counter % 2 === 1}
<Menu/>
{/if}
    
<style>
.hamburger{
    position:fixed;
    height: 22px;
    width: 28px;
    display: inline-block;
    box-sizing: border-box;
    margin:16px;
    z-index:10;
    cursor: pointer;
}
.hamburger-night div{
    background-color: #dddddd;
}
.bar1{
    position: absolute;
    left: 0;
    height: 2px;
    width: 24px;
    background-color: #444;
    border-radius: 2px;
    display: inline-block;
    box-sizing: border-box;
}
.bar2{
    position: absolute;
    left: 0;
    top:10px;
    height: 3px;
    width: 20px;
    background-color: #444;
    border-radius: 2px;
    display: inline-block;
    box-sizing: border-box;
}
.bar3{
    position: absolute;
    left: 0;
    top:21px;
    height: 2px;
    width: 28px;
    background-color: #444;
    border-radius: 2px;
    display: inline-block;
    box-sizing: border-box;
}
</style>